function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.82 13.07l-.142-.142.141.141a1.513 1.513 0 10-2.14-2.14 1.513 1.513 0 002.14 2.14zm.327-7.147l-.184-.077.184.077a1.513 1.513 0 10-2.794-1.158 1.513 1.513 0 002.794 1.158zM4.82 19.726l-.14-.142.14.142a1.512 1.512 0 000-2.14l-.14.142.14-.141a1.512 1.512 0 100 2.139zM21.376 4.3H7.687a.388.388 0 00-.387.388V6c0 .214.174.388.388.388h13.687A.388.388 0 0021.762 6V4.687a.388.388 0 00-.387-.387zm0 6.656H7.687a.388.388 0 00-.387.388v1.312c0 .214.174.388.388.388h13.687a.388.388 0 00.387-.388v-1.312a.388.388 0 00-.387-.388zm0 6.657H7.687A.388.388 0 007.3 18v1.313c0 .213.174.387.388.387h13.687a.388.388 0 00.387-.387V18a.388.388 0 00-.387-.387z"
});

var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "#6682A5"
  }, props), _ref);
};

export default SvgList;